import { ChatResponseInterface, UserInputInterface } from 'entities/interfaces';

export const createUserInput = (
  id: number,
  section_id: number,
  content: string
): UserInputInterface => ({
  id,
  section_id,
  content,
  type: 'userInput',
  isLeft: false,
  outputs: '',
  prompt: '',
  prompt_type: '',
  settings: '',
  status: '',
  title: '',
});

export const createChatResponse = (
  id: number,
  section_id: number,
  content: string
): ChatResponseInterface => ({
  id,
  section_id,
  content,
  type: 'response',
  isLeft: true,
  outputs: '',
  prompt: '',
  prompt_type: '',
  settings: '',
  status: '',
  title: '',
});
